/**
 * Created by kb on 2017/09/13.
 */
export const comConfig = {
  //启用停用状态
  enableState: [
    {value: '', label: "全部"},
    {value: 1, label: "启用"},
    {value: -1, label: "停用"},
    /*    {value: -2, label: "未启用"},*/
  ],
  approveState: [
    {value: '', label: "全部"},
    {value: 8, label: "自由态"},
    {value: 2, label: "审批中"},
    {value: 1, label: "审批通过"},
    {value: 0, label: "审批不通过"}
  ],
  // 客户状态
  AuditState: [
    {value: 1, label: "已审核"},
    {value: 2, label: "变更中"},
    {value: 3, label: "已变更"},
    {value: 5, label: "审核中"},
    {value: 9, label: "终止"},
  ],
  //客户来源
  source: [
    {value: 1, label: "导入"},
    {value: 2, label: "新增"},
  ],
  sources: [
    {value: 1, label: "导入"},
    {value: 3, label: "客户注册"},
  ],
  //付款单状态
  receivebillState: [
    {value: 1, label: "未核销"},
    {value: 2, label: "部分核销"},
    {value: 3, label: "已核销"},
  ],
  //付款单核销状态
  receivebillHxState: [
    {value: 1, label: "未审核"},
    {value: 5, label: "已审核 "},
  ],
  //付款单付款类型
  paymentType: [
    {value: 3, label: "线上"},
    {value: 4, label: "线下"},
  ],
  //付款单状态
  paymentState: [
    {value: 1, label: "申请"},
    {value: 2, label: "已审核"},
    {value: 3, label: "已支付"},
    {value: 4, label: "销售已审"},
    {value: 5, label: "财务已审"},
  ],

  // 单步审核
  singleAuditState: [
    {value: '', label: "全部"},
    {value: 0, label: "未审核"},
    {value: 1, label: "已审核"}
  ],


  orderState: [
    {value: '1', label: '未提交'},
    {value: '2', label: '已提交'},
    {value: '12', label: '超信用待确认'},
    {value: '13', label: '赠品待确认'},
    {value: '14', label: '运费待确认'},
    {value: '15', label: '收货地址待确认'},
    {value: '16', label: '运输方式待确认'},
    {value: '17', label: '待付款'},
    {value: '18', label: 'bpm审核中'},
    {value: '3', label: '待出库'},
    {value: '4', label: '完成出库'},
    {value: '5', label: '打包装箱'},
    {value: '6', label: '物流发运'},
    {value: '7', label: '派送中'},
    {value: '8', label: '物流签收'},
    {value: '9', label: '最终签收'},
    {value: '19', label: '订单关闭'}
  ],

  //导出类型
  derivation: [
    {value: 1, label: "导出本页"},
    {value: 3, label: "导出全部"}
  ],
  Productoption: [
    {
      enabled: 0,
      label: '全部'
    },
    {
      enabled: '1',
      label: '启用'
    },
    {
      enabled: '-1',
      label: '停用'
    }],
  pSizes: [10, 20, 30, 40],
  defSize: 10,
}

export const menuPage = {
  //用户设置界面权限编码
  pageCode: "",
  pageLevel: 0,
  pid: "",
  reqUrl: "",
  get loginUser() {
    try {
      return sessionStorage.getItem("user") == undefined || sessionStorage.getItem("user") == null ? {} : JSON.parse(sessionStorage.getItem("user"));
    } catch (e) {
      return {};
    }
  }
}


export const dataDictionary = {
  dic_icon: "menuIcon",
  dic_menuModule: "menuModule",
  dic_menuLevel: "menuLevel"
}






// WEBPACK FOOTER //
// ./src/commonJs/commonconf.js